import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
export default {
  DoGetPackageDetail() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetPackageDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoClearCacheGetPackageDetail() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/ClearCachePackage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCustomPriceList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetCustomPriceList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSubscriptionHistoryTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: input.isUseMainDatabase,
      subscriptionHistoryRequest: {
        fromDate: input.fromDate,
        toDate: input.toDate,
        subscriptionHistoryTableView: input.subscriptionHistoryTableView,
        tableSorting: input.tableSorting,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        statusId: input.statusId,
        searchText: input.searchText,
      },
    };
    return API.peakAPI
      .post("/api/Table/GetSubscriptionHistoryTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoAttachFileWhtPuunReceipt(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      puunWhtReceipt: {
        receiptId: input.receiptId,
        receiptNumber: input.receiptNumber,
        whtNumber: input.whtNumber,
        whtDate: input.whtDate,
        file: input.file,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/AttachFileWhtPuunReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPromoCodeDetail(promoCode) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      promoCode: promoCode.value,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetPromoCodeDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPackageRecurring() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetPackageRecurring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPackageScbQrCode(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetPackageScbQrCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPackageScbQrCodePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        language: i18n.locale,
        upgradePackageModel: input.upgradePackage,
        upgradePaymentModel: input.upgradePayment,
        upgradeComponentModel: input.upgradeComponent,
      },
    };
    return API.peakAppConnect.post("/api/SCB/GetPackageScbQrCode", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUpgradePackageByScbBilling(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      billPaymentRef1: input.billPaymentRef1,
      billPaymentRef2: input.billPaymentRef2,
      billPaymentRef3: input.billPaymentRef3,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetUpgradePackageByScbBilling", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpgradePackageScbQr(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      scbQr: input.scbQr,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/UpgradePackageScbQr", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpgradeToPackage(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradeToPackageData: input,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/UpgradeToPackage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpgradePackageBankTransfer(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      file: input.file,
      bankReference: input.bankReference,
      language: i18n.locale,
      upgradeComponent: {
        contactRequest: {
          contactRequestUuid:
            input.upgradeComponent && input.upgradeComponent.contactRequest
              ? input.upgradeComponent.contactRequest.contactRequestUuid
              : null,
        },
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/UpgradePackageBankTranfer", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpgradePackageOmise(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      cardCharge: input.cardCharge,
      language: i18n.locale,
      upgradeComponent: {
        contactRequest: {
          contactRequestUuid:
            input.upgradeComponent && input.upgradeComponent.contactRequest
              ? input.upgradeComponent.contactRequest.contactRequestUuid
              : null,
        },
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/UpgradePackageOmise", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpgradeRecurringOmise(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      cardCharge: input.cardCharge,
      language: i18n.locale,
      upgradeComponent: {
        contactRequest: {
          contactRequestUuid:
            input.upgradeComponent && input.upgradeComponent.contactRequest
              ? input.upgradeComponent.contactRequest.contactRequestUuid
              : null,
        },
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/UpgradeRecurringOmise", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeletePackageRecurring(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      reason: input,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/DeletePackageRecurring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoOmiseAddCard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardAttach: input,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/OmiseAddCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoOmiseGetCardList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/OmiseGetCardList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoOmiseRemoveCard(cardToken) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardRemove: {
        cardToken: cardToken,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/OmiseRemoveCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoOmiseDefaultCard(cardToken) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardAttach: {
        cardToken: cardToken,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/OmiseDefaultCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantUpgradePackageContactRequest() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/GetMerchantUpgradePackageContactRequest", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateUpgradePackageContactRequest(addressTemplate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      requestName: addressTemplate.requestName,
      contact: {
        ...addressTemplate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/CreateUpgradePackageContactRequest", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteUpgradePackageContactRequest(deleteAddressPackage) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      uuid: deleteAddressPackage.uuid,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Package/DeleteUpgradePackageContactRequest", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAttachmentWhtReceiptPuunFile(input) {
    let _input = {
      puunMerchantId: input.puunMerchantId,
      puunReceiptId: input.puunReceiptId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/File/GetAttachmentWhtReceiptPuunFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
};
